

let searchTimeout;

$(document).on("input", ".header_custom_search.desktop_only input", function () {
  const query = $(this).val().trim();

  clearTimeout(searchTimeout);

  if (query.length < 2) {
    $(".custom_header_search.desktop_only .custom_header_products").html("");
    $(".custom_header_search.desktop_only").removeClass("active");
    return;
  }

  // small debounce for performance
  searchTimeout = setTimeout(function () {
    $.ajax({
      url: "/search/suggest.json",
      data: {
        q: query,
        "resources[type]": "product",
        "resources[limit]": 6
      },
      dataType: "json",
      success: function (response) {
        const products = response.resources.results.products;
        let html = "";

        if (products.length) {
          products.forEach(function (product) {
            html += `
              <div class="custom_header_product_item">
                <a href="${product.url}" class="search_product_link">
                  <div class="custom_header_product_image">
                    <img src="${product.featured_image.url}" alt="${product.title}" width="auto" height="auto" loading="eager" fetchpriority="high">
                  </div>
                  <div class="custom_header_product_title">
                    ${product.title}
                  </div>
                </a>
              </div>
            `;
          });
        } else {
          html = `<div class="custom_header_product_item no_product_found">No products found</div>`;
        }

        $(".custom_header_search.desktop_only .custom_header_products").html(html);
        $(".custom_header_search.desktop_only").addClass("active");
      }
    });
  }, 300);
});




$(document).on("input", ".header_custom_search.mobile_only input", function () {
  const query = $(this).val().trim();

  clearTimeout(searchTimeout);

  if (query.length < 2) {
    $(".custom_header_search.mobile_only .custom_header_products").html("");
    return;
  }

  // small debounce for performance
  searchTimeout = setTimeout(function () {
    $.ajax({
      url: "/search/suggest.json",
      data: {
        q: query,
        "resources[type]": "product",
        "resources[limit]": 6
      },
      dataType: "json",
      success: function (response) {
        const products = response.resources.results.products;
        let html = "";

        if (products.length) {
          products.forEach(function (product) {
            html += `
              <div class="custom_header_product_item">
                <a href="${product.url}" class="search_product_link">
                  <div class="custom_header_product_image">
                    <img src="${product.featured_image.url}" alt="${product.title}" width="auto" height="auto" loading="eager" fetchpriority="high">
                  </div>
                  <div class="custom_header_product_title">
                    ${product.title}
                  </div>
                </a>
              </div>
            `;
          });
        } else {
          html = `<div class="custom_header_product_item no_product_found">No products found</div>`;
        }

        $(".custom_header_search.mobile_only .custom_header_products").html(html);
      }
    });
  }, 300);
});



$(document).on("click", ".open_searchcustom", function () {
$(".custom_header_search.mobile_only").addClass("active");
});
$(document).on("click", ".close_search_popup", function () {
$(".custom_header_search.mobile_only").removeClass("active");
});